module.exports = __webpack_public_path__ + "img/bed.0d176e36.svg";